import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { jobServices } from '../services/job.service';

export const useCreateJob = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => jobServices.createJob(data),
    onSuccess: () => {
      queryClient.invalidateQueries(['jobs']);
      queryClient.invalidateQueries(['jobStats']);
      toast.success('Job created successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to create job');
    },
  });
};

export const useUpdateJob = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ jobId, data }) => jobServices.updateJob({ jobId, data }),
    onSuccess: (data) => {
      queryClient.invalidateQueries(['jobs']);
      toast.success('Job updated successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update job');
    },
  });
};

export const useDeleteJob = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (jobId) => jobServices.deleteJob(jobId),
    onSuccess: () => {
      queryClient.invalidateQueries(['jobs']);
      toast.success('Job deleted successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete job');
    },
  });
};
